import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  KeyvaluePipe,
  NewlinePipe,
  SafeHtmlPipe,
  SortPipe,
  SpecificFlagPipe,
  TruncatePipe,
  SentenceCasePipe,
} from './index';

@NgModule({
  declarations: [
    KeyvaluePipe,
    NewlinePipe,
    SafeHtmlPipe,
    SortPipe,
    SpecificFlagPipe,
    TruncatePipe,
    SentenceCasePipe,
  ],
  imports: [CommonModule],
  exports: [
    KeyvaluePipe,
    NewlinePipe,
    SafeHtmlPipe,
    SortPipe,
    SpecificFlagPipe,
    TruncatePipe,
    SentenceCasePipe,
  ],
})
export class PipesModule {}
